// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports -- Content Preview descendants still require Relay while their DataRouter migration is pending.
import {RelayEnvironmentProvider, relayEnvironmentWithMissingFieldHandlerForNode} from '@github-ui/relay-environment'
import {useState} from 'react'

export function TaskChatDataProvider({children}: {children: React.ReactNode}) {
  const [environment] = useState(() => relayEnvironmentWithMissingFieldHandlerForNode())

  return <RelayEnvironmentProvider environment={environment}>{children}</RelayEnvironmentProvider>
}
